import storage from '~/services/storage'

export const getLoginUrl = () => {
  if (typeof window === 'undefined') return 'account/login'

  const currentPath = window.location.pathname
  const loginQuery =
    !currentPath.includes('login') && !currentPath.includes('logout')
      ? `?destination=${currentPath.replace(/\/$/, '')}`
      : ''

  return `account/login${loginQuery}`
}

// Speeds up logged in detection on initial page load and helps limit auth
// checks to users that should be logged in. Won't update like state.
export const isStorageLoggedIn = () => storage.getItem('auth-logged-in')
